export const FR_TRANSLATE = {
    "HELLO": "Bonjour",
    "back": "Retour",
    "ok": "Ok",
    "cancel": "Annuler",
    "startBtn": "Commencer",

    "detox": "Détox",
    "detoxPlan": "Menus et Recettes",
    "settings": "Paramètres",
    "shoppingList": "Liste de courses",
    "termsOfUse": "Conditions d'utilisation",
    "guides": "Guides",
    "aboutUs": "À propos de nous",
    "slogan": "21 jours de nettoyage corporel sain",

    "dailyMenu": "Menu quotidien",
    "day": "Jour",
    "finish": "Et maintenant",
    "ingredients": "Ingrédients",
    "instructions": "Instructions",
    "intro": "Introduction",
    "markThisDay": "Marquer ce jour comme fait",
    "serving": "Portion",
    "servings": "Portions",
    "meals": [
        {
            "name": "Petit déjeuner"
        },
        {
            "name": "En-cas du matin"
        },
        {
            "name": "Déjeuner"
        },
        {
            "name": "En-cas de l'après-midi"
        },
        {
            "name": "Dîner"
        }
    ],

    "more": "plus",
    "language": "Langue",

    "he": "עברית",
    "en": "English",
    "ge": "Deutsch",
    "ru": "русский",
    "fr": "français",
    "sp": "español",
    "po": "português",

    "unit": "Unité",
    "selectDetoxPlan": "Sélectionnez votre plan de détox",
    "detoxPlans": "Plans de détox",
    "restart": "Redémarrer",
    "start": "Commencer",
    "days": "jours",
    "standard": "standard",
    "vegan": "végétalien",
    "vegetarian": "végétarien",
    "pescetarian": "pescétarien",
    "wellDone": "Bien joué!",
    "whatsNow": "Quoi maintenant",

    "youDidIt": "Bien joué, vous l'avez fait",
    "weProud": "Nous sommes fiers de vous,",
    "presentYourself": "Vous vous êtes offert un cadeau incroyable",

    "messages": {
        "resetApp": {
            "title": "Réinitialiser l'application",
            "content": "Cette action réinitialisera la liste de courses et les jours marqués comme faits.\nAppuyez sur OK si vous souhaitez réinitialiser l'application."
        }
    },
}
